import { Container } from 'inversify';

import { TenantContext } from '@context/tenantContext';
import { AdeccoAdAuthHelper } from '@helpers/adeccoAdAuthHelper';
import { AppConfig } from '@helpers/appConfig';
import { AuthHelper } from '@helpers/authHelper';
import { FiscalCodeValidationITHelper } from '@helpers/fiscalCodeValidationITHelperp';
import { Utils } from '@helpers/utils';

import { AamBackendApi } from './libs/aamBackendApi';
import { GoogleMapsApi } from './libs/googleMapsApi';
import { TYPES } from './libs/InversifyType';
import { Logger } from './libs/logger';
import { UploadDocumentContex } from './libs/UploadDocumentContex';

export const container = new Container({
  skipBaseClassChecks: true,
});

// Helpers
container.bind<Utils>(TYPES.Utils).to(Utils).inSingletonScope();
container.bind<AppConfig>(TYPES.AppConfig).to(AppConfig).inSingletonScope();
container.bind<AuthHelper>(TYPES.AuthHelper).to(AuthHelper).inSingletonScope();
container.bind<AdeccoAdAuthHelper>(TYPES.AdeccoAdAuthHelper).to(AdeccoAdAuthHelper).inSingletonScope();
container
  .bind<FiscalCodeValidationITHelper>(TYPES.FiscalCodeValidationITHelper)
  .to(FiscalCodeValidationITHelper)
  .inSingletonScope();

// Context
container.bind<TenantContext>(TYPES.TenantContext).to(TenantContext).inSingletonScope();
container.bind<UploadDocumentContex>(TYPES.UploadDocumentContex).to(UploadDocumentContex).inSingletonScope();

// Libs
container.bind<AamBackendApi>(TYPES.AamBackendApi).to(AamBackendApi).inSingletonScope();
container.bind<GoogleMapsApi>(TYPES.GoogleMapsApi).to(GoogleMapsApi).inSingletonScope();
container.bind<Logger>(TYPES.Logger).to(Logger).inSingletonScope();

export const getAamBackendApi = () => container.get<AamBackendApi>(TYPES.AamBackendApi);
